const initialState = {
	initDate: "",
	endDate: "",
	withEvents: "N"
};

const positionReducer = (state = initialState, action) => {
	if (action.type === "events") {
		return { ...state, withEvents: action.value };
	}

	if (action.type === "initDate") {
		return { ...state, initDate: action.value };
	}
	
	if (action.type === "endDate") {
		return { ...state, endDate: action.value };
	}

	return state;
};

export default positionReducer;

